module.exports = {
  id: 20,
  name: 'Crab Walk',
  categories: ['strength', 'core', 'coordination'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'intermediate',
  skill: 'Core',
  points: 14,
  instructions:
    'Crab Walk makes you coordinated like a crab! Sit on the ground with your knees bent and feet flat, put your hands behind you, then lift your butt up and walk backwards like a crab! Ready to try it?',
  timedInstructions: [
    {
      time: 0,
      text: "You're a crab at a beach picnic! Let's get into crab position!",
    },
    {
      time: 2,
      text: 'Sit on the ground with your knees bent!',
    },
    {
      time: 4,
      text: 'Put your hands behind you, fingers pointing away!',
    },
    {
      time: 6,
      text: 'Lift your bottom up off the ground!',
    },
    {
      time: 8,
      text: 'Keep your feet flat, knees bent!',
    },
    {
      time: 10,
      text: 'Perfect crab position! 3, 2, 1, START WALKING!',
    },
    // SET 1: SANDWICH DELIVERY - 10 reps
    {
      time: 13,
      text: 'Mission: Deliver sandwiches to your crab friends!',
    },
    {
      time: 15,
      text: 'Right hand back, then your left foot back, keep moving!',
    },
    {
      time: 18,
      text: 'Left hand back, then your right foot back, stay balanced!',
    },
    {
      time: 21,
      text: 'Right hand back, left foot back, keep your bottom up high!',
    },
    {
      time: 24,
      text: "Left hand back, right foot back, don't let your bottom touch!",
    },
    {
      time: 27,
      text: 'Right hand back, left foot back, keep moving together!',
    },
    {
      time: 30,
      text: 'Left hand back, right foot back, your friends are hungry!',
    },
    {
      time: 33,
      text: 'Right hand back, left foot back, stay balanced and strong!',
    },
    {
      time: 36,
      text: 'Left hand back, right foot back, keep that bottom up!',
    },
    {
      time: 39,
      text: 'Right hand back, left foot back, almost there!',
    },
    {
      time: 42,
      text: 'Left hand back, right foot back, great crab walking!',
    },
    // REST PERIOD 1 - 20 seconds
    {
      time: 45,
      text: 'Amazing job! Take a good break now',
    },
    {
      time: 48,
      text: 'Breathe in and out, catch your breath',
    },
    {
      time: 51,
      text: "You just did 10 crab walks, that's incredible!",
    },
    {
      time: 54,
      text: 'Your coordination is getting so much better!',
    },
    {
      time: 57,
      text: 'Remember to keep your bottom up high',
    },
    {
      time: 60,
      text: 'Keep your hands and feet moving together',
    },
    {
      time: 63,
      text: 'Breathe deeply and relax your muscles',
    },
    {
      time: 66,
      text: "You're building amazing coordination!",
    },
    {
      time: 69,
      text: 'Ready for round two, crab warrior!',
    },
    {
      time: 72,
      text: '3, 2, 1, KEEP WALKING!',
    },
    // SET 2: BEACH BALL RETRIEVAL - 10 reps
    {
      time: 75,
      text: 'Mission: Get the beach ball that rolled away!',
    },
    {
      time: 78,
      text: 'Right hand back, then your left foot back, keep moving!',
    },
    {
      time: 81,
      text: 'Left hand back, then your right foot back, stay balanced!',
    },
    {
      time: 84,
      text: 'Right hand back, left foot back, keep your bottom up high!',
    },
    {
      time: 87,
      text: "Left hand back, right foot back, don't let your bottom touch!",
    },
    {
      time: 90,
      text: 'Right hand back, left foot back, keep moving together!',
    },
    {
      time: 93,
      text: "Left hand back, right foot back, don't let the ball roll away!",
    },
    {
      time: 96,
      text: 'Right hand back, left foot back, stay balanced and strong!',
    },
    {
      time: 99,
      text: 'Left hand back, right foot back, keep that bottom up!',
    },
    {
      time: 102,
      text: 'Right hand back, left foot back, almost to the ball!',
    },
    {
      time: 105,
      text: 'Left hand back, right foot back, great crab walking!',
    },
    // REST PERIOD 2 - 20 seconds
    {
      time: 108,
      text: 'Incredible work! Take another break',
    },
    {
      time: 111,
      text: 'Breathe in and out, feel your coordination',
    },
    {
      time: 114,
      text: 'You just did 20 crab walks total!',
    },
    {
      time: 117,
      text: 'Your coordination is getting stronger!',
    },
    {
      time: 120,
      text: 'Remember to keep your bottom up high',
    },
    {
      time: 123,
      text: 'Keep your hands and feet moving together',
    },
    {
      time: 126,
      text: 'Breathe deeply and relax your muscles',
    },
    {
      time: 129,
      text: "You're becoming a crab walk master!",
    },
    {
      time: 132,
      text: 'Ready for round three, crab champion!',
    },
    {
      time: 135,
      text: '3, 2, 1, KEEP WALKING!',
    },
    // SET 3: ICE CREAM DELIVERY - 10 reps
    {
      time: 138,
      text: 'Mission: Deliver ice cream before it melts!',
    },
    {
      time: 141,
      text: 'Right hand back, then your left foot back, keep moving!',
    },
    {
      time: 144,
      text: 'Left hand back, then your right foot back, stay balanced!',
    },
    {
      time: 147,
      text: 'Right hand back, left foot back, keep your bottom up high!',
    },
    {
      time: 150,
      text: "Left hand back, right foot back, don't let your bottom touch!",
    },
    {
      time: 153,
      text: 'Right hand back, left foot back, keep moving together!',
    },
    {
      time: 156,
      text: 'Left hand back, right foot back, the ice cream is melting!',
    },
    {
      time: 159,
      text: 'Right hand back, left foot back, stay balanced and strong!',
    },
    {
      time: 162,
      text: 'Left hand back, right foot back, keep that bottom up!',
    },
    {
      time: 165,
      text: 'Right hand back, left foot back, hurry up!',
    },
    {
      time: 168,
      text: 'Left hand back, right foot back, great crab walking!',
    },
    // REST PERIOD 3 - 20 seconds
    {
      time: 171,
      text: 'Fantastic work! Take a final break',
    },
    {
      time: 174,
      text: 'Breathe in and out, feel your strength',
    },
    {
      time: 177,
      text: 'You just did 30 crab walks total!',
    },
    {
      time: 180,
      text: 'Your coordination is absolutely amazing!',
    },
    {
      time: 183,
      text: 'Remember to keep your bottom up high',
    },
    {
      time: 186,
      text: 'Keep your hands and feet moving together',
    },
    {
      time: 189,
      text: 'Breathe deeply and relax your muscles',
    },
    {
      time: 192,
      text: "You're a crab walk superstar!",
    },
    {
      time: 195,
      text: 'Ready for the final round, crab master!',
    },
    {
      time: 198,
      text: '3, 2, 1, FINAL WALK!',
    },
    // SET 4: SUNSET WALK - 10 reps
    {
      time: 201,
      text: 'Mission: Walk to watch the sunset!',
    },
    {
      time: 204,
      text: 'Right hand back, then your left foot back, keep moving!',
    },
    {
      time: 207,
      text: 'Left hand back, then your right foot back, stay balanced!',
    },
    {
      time: 210,
      text: 'Right hand back, left foot back, keep your bottom up high!',
    },
    {
      time: 213,
      text: "Left hand back, right foot back, don't let your bottom touch!",
    },
    {
      time: 216,
      text: 'Right hand back, left foot back, keep moving together!',
    },
    {
      time: 219,
      text: 'Left hand back, right foot back, the sun is setting!',
    },
    {
      time: 222,
      text: 'Right hand back, left foot back, stay balanced and strong!',
    },
    {
      time: 225,
      text: 'Left hand back, right foot back, keep that bottom up!',
    },
    {
      time: 228,
      text: 'Right hand back, left foot back, almost to the sunset!',
    },
    {
      time: 231,
      text: 'Left hand back, right foot back, great crab walking!',
    },
    {
      time: 234,
      text: 'You did it, beach crab champion!',
    },
    {
      time: 237,
      text: 'Incredible work! You did 40 crab walks!',
    },
    {
      time: 240,
      text: 'Your coordination is absolutely amazing!',
    },
    {
      time: 243,
      text: 'You are a crab walk master!',
    },
  ],
};
